import { useEffect, useState } from "react";

const Q = "(min-width: 1024px)";

export const useIsDesktop = () => {
  const [desktop, setDesktop] = useState(() => window.matchMedia(Q).matches);
  useEffect(() => {
    const m = window.matchMedia(Q);
    const on = (e) => setDesktop(e.matches);
    m.addEventListener("change", on);
    return () => m.removeEventListener("change", on);
  }, []);
  return desktop;
};

export default useIsDesktop;
